<div>
  <div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
  </div>
  <div class="login-page" style="padding:10px">
    <div class="card card-outline" style="width:auto;"> 
      <div>
        <button type="button" class="close position-absolute" (click)="close()" style="right: 10px;"> &times;</button>
      </div>

      <div class="login-logo" style="padding:20px">
        <a class="welcome-text">
          Welcome to <strong>MyRoots</strong> Portal
        </a>
        <br>
        <div><img src="assets/dmk.png" alt="Logo" class="" style="width:100px;">
        </div>
      </div>
      <div class="card-body login-card-body ">
        <form [formGroup]='sendmail' (ngSubmit)="postdata(sendmail)">
          <div>
            <div class="form-group">
              <label><b>Enter Your Registered Mail Id (Mentor and Student only)</b><span
                  style="color: red;font-weight: bold;">*</span></label>
              <input type="email" formControlName="email" class="form-control ps-2" formControlName="email"
                (keyup)="getemail(sendmail.get('email').value)" style="width:100%;">
              <div class="invalid-msg"
                *ngIf="sendmail.get('email').value !='' && sendmail.get('email').status=='INVALID';else errMsg">Please
                enter valid email</div>
              <ng-template #errMsg>
                <div class="invalid-msg"
                  *ngIf="test_email=='false' && sendmail.get('email').value !='' && sendmail.get('email').status=='VALID'">
                  This email is doesn't exist</div>
              </ng-template>
            </div>
            <div class="d-flex justify-content-center">
              <button class="btn btn-block btn-primary col-4" [disabled]="sendmail.invalid">Submit</button>
            </div>
          </div>


        </form>
      </div>

    </div>
  </div>
</div>